<template>
    <v-container class="content-container content-container--narrow">
        <v-row>
            <v-col>

                <!-- Main panel -->
                <div class="panel">

                    <div class="d-flex justify-space-between align-start">

                        <!-- Panel title -->
                        <div class="panel__title">
                            {{ $t(`ZakljucekPogodbe.Title`) }}
                            <img src="@assets/images/general/chevron.png" alt="Chevron right">
                            <span class="panel__title__step">
                                {{ $t(`ZakljucekPogodbe.Dokumentacija.Subtitle`) }}
                            </span>
                        </div>

                        <!-- Icon close -->
                        <img src="@assets/images/general/icon-close.svg" alt="Close" class="icon-close mt-1" @click="dokoncanjePogodbeStore.closeDokoncanjePogodbe" >

                    </div>

					<!-- Alert error -->
					<div class="alert alert--error mb-10" v-if="dokoncanjePogodbeStore.FormState.ErrorText.length > 0 ? true : false">
						<img src="@assets/images/general/icon-cancel.svg" alt="Cancel">
						{{dokoncanjePogodbeStore.FormState.ErrorText}}
					</div>
                    
					<!-- Alert success -->
					<div class="alert alert--success mb-10" v-if="dokoncanjePogodbeStore.FormState.SuccessText.length > 0 ? true : false">
						<img src="@assets/images/general/icon-check-circle.svg" alt="Cancel">
						{{dokoncanjePogodbeStore.FormState.SuccessText}}
					</div>

                    <!-- Panel content -->
                    <div class="panel__content">   
                        
                        <!-- ******** PARTNER DOCUMENTATION ********* -->
                        <v-row justify="space-between" no-gutters class="mb-5" v-if="dokoncanjePogodbeStore.Pogodba.DIYType == 'POS'">
                                
                            <v-col>
                                
                                <!-- Partner documentation title  -->
                                <div class="panel__subtitle mb-3 primary">
                                    {{ $t(`ZakljucekPogodbe.ProdajnoMesto.Title`) }}
                                </div>
                                
                                <!-- Partner info text -->
                                <div class="documentation-info documentation-info--bg mb-2">
                                    <img src="@assets/images/contract-create/icon-attachement.svg" alt="Attachment">
                                    <div>
                                        {{ $t(`ZakljucekPogodbe.ProdajnoMesto.TextInfo`) }}
                                    </div>
                                </div>
                                
                            </v-col>
                            
                        </v-row>

                        <v-row justify="space-between" no-gutters class="mb-5">
                            
                            <v-col>
                                
                                <!-- Številka veznega dokumenta -->
                                <div class="mb-2">
                                    <label class="form-label">
                                        {{ $t(`ZakljucekPogodbe.ProdajnoMesto.InputTitle`) }}
                                    </label>
                                    <TextInputUppercase
                                        v-model="dokoncanjePogodbeStore.DokoncanjeDokumentacije.DocumentNumber"
                                        :error-messages="v$.DocumentNumber.$errors[0] != null ? v$.DocumentNumber.$errors[0].$message : ''"
                                        @focus="v$.DocumentNumber.$reset"
                                        variant="outlined"
                                        :hint="$t(`ZakljucekPogodbe.ProdajnoMesto.InputInfo`)"
                                        persistent-hint
                                        >
                                    </TextInputUppercase>
                                </div>
                                
                            </v-col>
                            
                            <v-col class="v-col-1 d-none d-md-block"></v-col>
                            
                            <v-col>
                                
                                <!-- Prilaganje datotek (veznega dokumenta) -->
                                <div class="mb-2">
                                    <label class="form-label">
                                        {{ $t(`ZakljucekPogodbe.ProdajnoMesto.FormUploadTitle`) }}
                                    </label>
                                    <FileUpload 
                                        v-model="dokoncanjePogodbeStore.DokoncanjeDokumentacije.BindingFiles"
                                        :errorText="v$.BindingFiles.$errors[0] != null ? v$.BindingFiles.$errors : []"
                                    ></FileUpload>
   
                                    
                                    <div class="v-input__details">
                                        <div class="v-messages">
                                            <div class="v-messages__message">
                                                {{ $t(`ZakljucekPogodbe.ProdajnoMesto.FormUploadInfo`) }}
                                            </div>	
                                        </div>
                                    </div>
                                </div>
                            </v-col>

                        </v-row>
                        <!-- ******** END PARTNER DOCUMENTATION ********* -->
                    </div>

                    <!-- TO-DO -->
                    <!-- Panel footer -->
					<div class="d-flex ga-4"  v-if="dokoncanjePogodbeStore.Pogodba.DIYType == 'POS'">
                        <v-btn 
                            @click="NextPage()" 
                            flat size="large" 
                            class="btn btn--primary-fill"
                            >
                            {{ $t(`ZakljucekPogodbe.Btn.Next`) }}
                            <img src="@assets/images/general/icon-arrow-right.svg" alt="Arrow right" class="ml-2">
                        </v-btn>
                    </div>

                </div>
            </v-col>
        </v-row>
    </v-container>
</template>

<script setup lang="ts">
    import { computed } from "vue";
    import { useDokoncanjePogodbeStore } from "@/app/store/app/contract-completion/store";
    import TextInputUppercase from "@components/text-input-uppercase.vue";
    import FileUpload from "@components/file-upload.vue"
    import { i18n } from "@app/i18n";
    import { useVuelidate } from "@vuelidate/core";
	import { helpers, requiredIf } from "@vuelidate/validators";
    import router from "@/app/router";

    const dokoncanjePogodbeStore = useDokoncanjePogodbeStore();

    dokoncanjePogodbeStore.Steps.Pogodba.disabled = true;
    dokoncanjePogodbeStore.Steps.Dokumentacija.disabled = false;
    dokoncanjePogodbeStore.Steps.Identifikacija.disabled = true;
    dokoncanjePogodbeStore.Steps.Zakljucek.disabled = true;
    dokoncanjePogodbeStore.Steps.Pogodba.done = true;

    async function NextPage(){
        await validateForm().then(() => {
            router.push({ name: "dokoncanje_identifikacija" });
        });
    }

    async function validateForm(): Promise<void>{
        v$.value.$touch();
        let formValid = await v$.value.$validate();                
        return new Promise((resolve) => {                
            if(formValid){
                resolve();
            }
        });
    };

    const validationRules = computed(() => ({
        DocumentNumber: {
		    customRequired: helpers.withMessage(i18n.global.t("GlobalErrors.FIELD_REQUIRED"), requiredIf(dokoncanjePogodbeStore.Pogodba.DIYType == 'POS'))

        },
        BindingFiles: {
			customRequired: helpers.withMessage(i18n.global.t("GlobalErrors.FileAdd"), requiredIf(dokoncanjePogodbeStore.Pogodba.DIYType == 'POS' && dokoncanjePogodbeStore.DokoncanjeDokumentacije.BindingFiles.length == 0)),

        }
    }));

    const v$: any = useVuelidate(validationRules, dokoncanjePogodbeStore.DokoncanjeDokumentacije, {$autoDirty: true});
</script>